import React, { useEffect, useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import DeviceCarousel from '../device-carousel/DeviceCarousel';
import DeviceNotification from '../eir-device-notification/DeviceNotification';
import FAQ from '../faq/FAQ';
import Constants from '../../Constants';
import PubSub from 'pubsub-js';
import Routing from '../../utils/Routing';
import EirColourSelector from '../colour-selector/EirColourSelector';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';
import { PREPAY_PLAN_URL, PREPAY_REVIEW_URL } from '../eir-prepay-constants/ApplicationConstants';
import Loading from '../shared/Loading';

function EirPrepayDeviceDetails(props) {
    const graphql = useApolloClient();
    const [selectedVariant, setSelectedVariant] = useState([]);
    const [carouselImages, setCarouselImages] = useState([]);
    const [porting, setPorting] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        getSelectedVariant();
        getCarouselImages();
    }, []);
    const convertFeaturesAndSpecificationsToFaq = () => {
        var faqs = [
            {
                question: 'KEY FEATURES',
                answer: renderFeatures(),
            },
            {
                question: 'DETAILED SPECIFICATIONS',
                answer: renderSpecifications(),
            },
        ];
        return faqs;
    };
    const renderFeatures = () => {
        if (props.device.details.features) {
            let features = [];
            props.device.details.features.forEach(feature => {
                features.push(<li>{feature}</li>);
            });
            return <ul>{features}</ul>;
        }
    };
    const renderSpecifications = () => {
        let specs = [];
        if (props.device.details.specifications) {
            props.device.details.specifications.forEach(spec => {
                specs.push(<li>{spec}</li>);
            });
            return <ul>{specs}</ul>;
        }
    };
    const getSelectedVariant = () => {
        let variant = null;
        /*  if (Routing.urlHasQuery()) {
          variant = props.device.variants.filter(variant => variant.name.toLowerCase() == Routing.getQueryParameter('variant').toLowerCase())[0];
        }*/

        if (!variant) {
            variant = props.device.variants.filter(variant => variant.inStock)[0];
        }

        if (!variant) {
            variant = props.device.variants[0];
        }
        setSelectedVariant(variant);
    };

    const getCarouselImages = () => {
        if (
            selectedVariant &&
            selectedVariant.carouselImages &&
            selectedVariant.carouselImages.length
        ) {
            setCarouselImages(selectedVariant.carouselImages);
        } else {
            for (let i = 0; i < props.device.variants.length; i++) {
                if (
                    props.device.variants[i].carouselImages &&
                    props.device.variants[i].carouselImages.length > 0
                ) {
                    setCarouselImages(props.device.variants[i].carouselImages);
                }
            }
        }
        if (selectedVariant && selectedVariant.image && selectedVariant.image.path) {
            setCarouselImages(selectedVariant.image.path);
        } else {
            for (let i = 0; i < props.device.variants.length; i++) {
                if (props.device.variants[i].image && props.device.variants[i].image.path) {
                    setCarouselImages(props.device.variants[i].image.path);
                }
            }
        }
    };

    const setVariant = selectedVariant => {
        setSelectedVariant(selectedVariant);
        getCarouselImages();
    };
    const selectPhone = event => {
        let portVal = event.target.parentNode.parentNode.value;
        setPorting(event.target.parentNode.parentNode.value);
        setIsLoading(true);
        createProspect(props.device, portVal);
    };
    const createProspect = async (device, portVal) => {
        try {
            if (localStorage.getItem('prospectUuid')) {
                addOffer(device, portVal);
            } else {
                const res = await graphql.mutate({
                    mutation: ENDPOINT.CREATE_PROSPECT,
                    variables: {
                        brand: props.openCMSProps.brand,
                        channelType: props.openCMSProps.channelType,
                        offerType: props.openCMSProps.offerType,
                    },
                });
                if (res.data.prospect) {
                    // console.log('gggg');
                    localStorage.setItem('IONOrderReference', res.data.prospect.orderReference);
                    localStorage.setItem('prospectUuid', res.data.prospect.prospectUuid);
                    document.cookie =
                        'eir_current_order= ;expires=Thu, 01 Jan 2000 00:00:00 UTC; path=/';
                    addOffer(device, portVal);
                }
            }
        } catch (err) {
            props.getAPIError('Sorry, something went wrong,  please try again later.');
            props.getsetDialogOpenResponse(true);
            console.log(err.message);
            setIsLoading(false);
        }
    };

    const addOffer = async (device, portVal) => {
        try {
            let offerName = props.openCMSProps.offerName;
            if (localStorage.getItem('offerId')) {
                if (portVal == 'PORT') {
                    getDiscount();
                } else {
                    removeDiscount();
                }
                addPhone(device);
            } else {
                const res = await graphql.mutate({
                    mutation: ENDPOINT.ADD_OFFER,
                    variables: {
                        prospectUuid: localStorage.getItem('prospectUuid'),
                        offerName: offerName,
                    },
                });
                if (res.data.addOffer) {
                    localStorage.setItem('offerId', res.data.addOffer.offerId);
                    if (portVal == 'PORT') {
                        getDiscount();
                    } else {
                        removeDiscount();
                    }
                    addPhone(device);
                }
            }
        } catch (err) {
            props.getAPIError('Sorry, something went wrong,  please try again later.');
            props.getsetDialogOpenResponse(true);
            console.log(err.message);
            setIsLoading(false);
        }
    };
    const addPhone = async device => {
        try {
            const res = await graphql.mutate({
                mutation: ENDPOINT.ADD_HANDSET,
                variables: {
                    prospectUuid: localStorage.getItem('prospectUuid'),
                    cartOfferId: parseInt(localStorage.getItem('offerId')),
                    deviceId: parseInt(device.id),
                    catalogHandsetCode: selectedVariant.catalogHandsetCode,
                },
            });
            if (res.data.addHandset) {
                PubSub.publish(Constants.eventKeys.cartSubscriberAdded, res.data.addHandset);
                if (localStorage.getItem('plan-name')) {
                    localStorage.setItem('handset-name', device.name);
                    window.location.href = PREPAY_REVIEW_URL;
                } else {
                    localStorage.setItem('handset-name', device.name);
                    window.location.href = PREPAY_PLAN_URL;
                }
                setIsLoading(false);
            }
        } catch (err) {
            console.log(err.message);
            setIsLoading(false);
        }
    };
    const getDiscount = async () => {
        try {
            let offerName = props.openCMSProps.offerName;
            const res = await graphql.query({
                query: ENDPOINT.GET_DISCOUNT,
                variables: { offerName: offerName },
            });
            if (res.data.discounts) {
                addDiscount(res.data.discounts[0].catalogDiscountCode);
            }
        } catch (err) {
            console.log(err.message);
            setIsLoading(false);
            props.getAPIError('Sorry, something went wrong,  please try again later.');
            props.getsetDialogOpenResponse(true);
        }
    };
    const addDiscount = async discountId => {
        try {
            await graphql.mutate({
                mutation: ENDPOINT.ADD_DISCOUNT,
                variables: {
                    prospectUuid: localStorage.getItem('prospectUuid'),
                    cartOfferId: parseInt(localStorage.getItem('offerId')),
                    catalogDiscountCode: discountId,
                },
            });
        } catch (err) {
            props.getAPIError('Sorry, something went wrong,  please try again later.');
            props.getsetDialogOpenResponse(true);
            console.log(err.message);
            setIsLoading(false);
        }
    };
    const removeDiscount = async () => {
        try {
            await graphql.mutate({
                mutation: ENDPOINT.REMOVE_DISCOUNT,
                variables: {
                    prospectUuid: localStorage.getItem('prospectUuid'),
                    cartOfferId: parseInt(localStorage.getItem('offerId')),
                },
            });
        } catch (err) {
            props.getAPIError('Sorry, something went wrong,  please try again later.');
            props.getsetDialogOpenResponse(true);
            console.log(err.message);
            setIsLoading(false);
        }
    };
    return (
        <div>
            <Grid className='d-flex flex-column' sm={12}>
                <div className='order-1'>
                    <h6 className='text-uppercase text-base-gray mb-2 company-name-title'>
                        {props.device.manufacturer}
                    </h6>
                    <h1 className='text-black mb-4 company-variant-title'>
                        {props.device.displayName || props.device.model}
                    </h1>
                </div>

                <div className='order-2 d-lg-none mb-5'>
                    <DeviceCarousel images={carouselImages}>
                        <DeviceNotification
                            device={props.device}
                            selectedVariant={selectedVariant}
                        />
                    </DeviceCarousel>
                </div>

                <div className='order-3 mb-5'>
                    <div className='d-flex justify-content-between'>
                        <h6 className='text-left text-uppercase text-base-gray color-text mb-md-2'>
                            COLOUR
                        </h6>
                        <h6 className='text-right text-uppercase text-danger mb-md-2 status-text-position'>
                            {selectedVariant.stockStatus}
                        </h6>
                    </div>

                    <EirColourSelector
                        colourOptions={props.device.variants}
                        selectedColour={selectedVariant}
                        large={true}
                        onColourSelected={setVariant}
                    />
                </div>

                <div className='order-4 order-lg-2 mb-4 phone-details-text-container'>
                    <div
                        className='phone-details-text'
                        dangerouslySetInnerHTML={{ __html: props.device.details.description }}
                    />
                </div>

                {selectedVariant.inStock && !isLoading && (
                    <div className='order-5'>
                        <h6 className='text-uppercase text-base-gray color-text mb-3'>
                            PHONE COST
                        </h6>
                        <div className='order-5'>
                            <Button
                                className='button-two-label'
                                sm={4}
                                onClick={selectPhone}
                                value='PORT'>
                                <span className='button-label-one'>Transfer number to eir</span>
                                <span className='button-label-two'>
                                    &euro;
                                    {props.device.details.prices
                                        .filter(priceList => priceList.mobileOrderType === 'PORT')
                                        .map(price => price.price)}
                                </span>
                            </Button>

                            <Button className='button-two-label' onClick={selectPhone} value='NEW'>
                                <span className='button-label-one'>Get a new number</span>
                                <span className='button-label-two'>
                                    &euro;
                                    {props.device.details.prices
                                        .filter(priceList => priceList.mobileOrderType === 'NEW')
                                        .map(price => price.price)}
                                </span>
                            </Button>
                        </div>
                    </div>
                )}
                {selectedVariant.inStock && isLoading && (
                    <div className='order-5'>
                        <h6 className='text-uppercase text-base-gray color-text mb-3'>
                            PHONE COST
                        </h6>
                        <div className='order-5 phone-details-text-container'>
                            <Loading></Loading>
                        </div>
                    </div>
                )}
            </Grid>
            <Grid
                sm={5}
                className='d-none d-lg-flex align-items-stretch flex-column carousel-position'>
                <DeviceCarousel images={carouselImages}>
                    <DeviceNotification device={props.device} selectedVariant={selectedVariant} />
                </DeviceCarousel>
            </Grid>
            <Grid sm={12} className='d-none d-lg-flex align-items-stretch flex-column faq-buttom'>
                <FAQ Title='' faqs={convertFeaturesAndSpecificationsToFaq()} />
            </Grid>
        </div>
    );
}
export default EirPrepayDeviceDetails;
